import { AfterViewInit, Component, effect, ElementRef, EventEmitter, Input, model, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { HisOptionWidget } from '../model/his-widget-option';

@Component( {
    selector: 'his-search-checkbox',
    templateUrl: './his-search-checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchCheckboxComponent implements AfterViewInit {
    @Input() widget: HisOptionWidget;

    @Input() isFirstInputElement = false;
    @ViewChild( 'inputElement' ) inputElement: ElementRef;

    @Output() changed = new EventEmitter<string | null>();

    protected checked = model( false );

    constructor() {
        effect( () => {
            const widgetCheckedState = this.widget.checkboxValueChanged();
            if ( this.checked() !== widgetCheckedState ) {
                this.checked.set( widgetCheckedState );
            }
        } );
    }

    ngAfterViewInit() {
        // Set focus on first input element
        if ( this.isFirstInputElement ) {
            setTimeout( () => this.inputElement.nativeElement.focus() );
        }
    }

    getHtmlFocusElementId(): string {
        return this.widget.uid;
    }

    change() {
        this.widget.value = this.checked();
        this.changed.emit( this.widget.value );
    }
}
